import { PaginationResponse } from "../../../../model/base/response/pagination-response";
import { IOfficialDiaryPagedRequest } from "../../../../model/official-daily/request/official-diary-paged-request";
import { IOfficialDiaryPagedResponse } from "../../../../model/official-daily/response/official-diary-paged-response";


export type ConsultaDiarioOficialState = {
    officialDiaryPagedRequest: IOfficialDiaryPagedRequest;
    officialDiaryPagedResponse: PaginationResponse<IOfficialDiaryPagedResponse>;
    isLoadingData: boolean;
};

export enum ACTION_TYPES {
    setOfficialDiaryPagedRequest = 'setOfficialDiaryPagedRequest',
    setOfficialDiaryPagedResponse = 'setOfficialDiaryPagedResponse',
    setIsLoadingData = 'setIsLoadingData',

}

export const ConsultaDiarioOficialReducer = (state: ConsultaDiarioOficialState, action: any): ConsultaDiarioOficialState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setOfficialDiaryPagedRequest:
            return {
                ...state,
                officialDiaryPagedRequest: payload,
            };
        case ACTION_TYPES.setOfficialDiaryPagedResponse:
            return {
                ...state,
                officialDiaryPagedResponse: payload,
            };
        case ACTION_TYPES.setIsLoadingData:
            return {
                ...state,
                isLoadingData: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}